<template>
  <div class="registration-card" :style="{backgroundColor: planData.primaryColor}">
    <div class="test">

        <h1 class="font-weight-bold fs-45" v-text="planData.name"></h1>

        <p class="push-10-t fs-18">{{ planData.description }}</p>
        <div v-if="planHasCustomPricing">
            <em class="text-muted fs-12 push-15-t dis-block"></em>
            <h1 class="inline-block text-white">Let's Talk</h1> <br/>
            <div class="push-5-t"></div>
            <span class="font-italic">1 or 3-year terms available <br/>+ custom transaction fees</span>
        </div>
        <div v-else-if="!isSelfPay">
            <h1 class="inline-block">${{ planData.cost }}</h1>
            <span class="h5 text-light" v-if="planData.key == 'essential'">&nbsp; per month</span>
            <span class="h5 text-light" v-if="planData.key == 'professional'">&nbsp; /user <br/><p>per month</p></span> 
        </div>

        <div class="row push-20-t">
          <div class="col-xs-10 col-xs-offset-1">
              <div class="text-left push-10 font-weight-bold" v-for="(feature, idx) in planData.features" :key="idx">
                <img src="/assets/img/check-mark-white.svg" class="push-10-r">
                <span v-html="feature"></span>
              </div>
          </div>
        </div>

        <template v-if="showTransactionFees">
          <div class="row push-20-t">
          <h2 class="text-white text-center pt-20 pb-0 fs-24" style="">Transaction Fees</h2>
          <div class="col-xs-10 col-xs-offset-1 push-10-t">
            <TransactionFees :couponCode="'test'" :currentUser="currentUser" :plan="plan" :coupon="coupon"></TransactionFees>
          </div>
        </div>
        </template>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-facing-decorator'; 
import RefreshPlanConstants from '../../../constants/refreshPlans';
import UserConstants from '../../../constants/users';
import UserTypes from '../../../types/users';
import TransactionFees from './TransactionFees.vue';

@Component({
  components: {
    TransactionFees
  }
})
export default class PlanOffering extends Vue {
  @Prop({ type: String, required: true }) plan!: string;
  @Prop({ type: Object }) currentUser!: UserTypes.User;
  @Prop({ type: String }) coupon!: string;

  get planData(): any {
    return RefreshPlanConstants.plans.TYPES.find((el: { key: string }) => { return el.key == this.plan });
  }
  get planHasCustomPricing(): boolean {
    return [UserConstants.accountTypes.ENTERPRISE].indexOf(this.planData.key) >= 0 && !this.isSelfPay;
  }
  get isSelfPay(): boolean {
    return this.planData.key == UserConstants.accountTypes.ENTERPRISE_SELF_PAY_REP;
  }
  get showTransactionFees(): boolean {
    return this.plan != UserConstants.accountTypes.ENTERPRISE && 
    this.plan != UserConstants.accountTypes.ENTERPRISE_SELF_PAY_REP && 
    !!this.currentUser && 
    this.$featureEnabled('TransactionFeesUI')
  }
}
</script>
